import * as React from 'react'

/**
 * @description Rocket icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Rocket } from '@sravni/design-system-icons'
 *
 * <Rocket />
 * ```
 */
export const Rocket = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="Rocket" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m10.783 9.217-5.891 5.891M5.528 10.832l-2.886-.681a.417.417 0 0 1-.2-.7l2.296-2.295a.833.833 0 0 1 .582-.244l2.588-.023"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m16.566 7.48.673-3.24a1.25 1.25 0 0 0-1.478-1.48l-3.24.674c-.954.199-1.83.671-2.518 1.36L7.345 7.452A6.672 6.672 0 0 0 5.463 11.2l-.01.06a2.897 2.897 0 0 0 3.286 3.285l.061-.008a6.667 6.667 0 0 0 3.748-1.883l2.658-2.657a4.995 4.995 0 0 0 1.36-2.518v0Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.167 3.928a18.68 18.68 0 0 1 4.905 4.905M9.167 14.473l.681 2.885c.075.318.47.43.7.2l2.295-2.296a.833.833 0 0 0 .245-.582l.022-2.588"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
))
